"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: theme.spacing(2)
    },
    center: {
        display: 'flex',
        alignItems: 'center'
    },
    imageCard: {
        [theme.breakpoints.up('sm')]: {
            width: 445,
            marginRight: theme.spacing(2)
        },
        [theme.breakpoints.only('xs')]: {
            width: 280
        },
        overflow: 'inherit'
    },
    headerImage: {
        display: 'flex',
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            height: 445,
            width: 445
        },
        [theme.breakpoints.only('xs')]: {
            height: 280,
            width: 280
        }
    },
    button: {
        marginTop: theme.spacing(),
        minWidth: 270,
        display: 'block',
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            minWidth: '100%'
        }
    },
    buttonLabelIcon: {
        fontSize: 16
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        }
    },
    spacing: {
        marginBottom: theme.spacing(2)
    },
    largeIcon: {
        fontSize: '2.5rem'
    },
    textButton: {
        textTransform: 'none'
    },
    termText: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'left'
        }
    },
    previewText: {
        position: 'absolute',
        top: '59%',
        left: '35%',
        fontSize: '20px',
        border: 'none',
        color: 'white',
        fontWeight: 500,
        textShadow: '0 0 10px rgba(0,0,0,0.8)'
    },
    playIcon: {
        position: 'absolute',
        top: '40%',
        left: '42%',
        height: '70px!important',
        width: '70px!important',
        cursor: 'pointer',
        transition: 'transform .5s ease-in-out',
        '&:hover': {
            transform: 'scale(1.3)'
        }
    },
    parentDiv: { position: 'relative' },
    overlay40: {
        filter: 'brightness(0.6)'
    },
    iframe: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        [theme.breakpoints.down('md')]: {
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            margin: 0,
            maxHeight: '95%',
            position: 'absolute'
        },
        border: 0
    },
    multiplierDetails: {
        display: 'flex',
        padding: '1rem',
        alignItems: 'center',
        marginBottom: theme.spacing(2)
    },
    mDetailsHeader: {
        fontSize: '3rem',
        fontWeight: 800,
        padding: '1.5rem 0.25rem'
    }
});
exports.default = styles;
//# sourceMappingURL=InteractiveGameStyle.js.map